var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_3247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2273 7.72723H1.59096C1.1642 7.72723 0.818237 8.07319 0.818237 8.49996C0.818237 8.92672 1.1642 9.27268 1.59096 9.27268H23.2273C23.6541 9.27268 24 8.92672 24 8.49996C24 8.07319 23.6541 7.72723 23.2273 7.72723Z",
    fill: "#68C6AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2273 15.4546H1.59096C1.1642 15.4546 0.818237 15.8006 0.818237 16.2273C0.818237 16.6541 1.1642 17 1.59096 17H23.2273C23.6541 17 24 16.6541 24 16.2273C24 15.8006 23.6541 15.4546 23.2273 15.4546Z",
    fill: "#68C6AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2272 0H1.59084C1.16408 0 0.818115 0.345961 0.818115 0.772725C0.818115 1.19949 1.16408 1.54545 1.59084 1.54545H23.2272C23.654 1.54545 23.9999 1.19949 23.9999 0.772725C23.9999 0.345961 23.654 0 23.2272 0Z",
    fill: "#68C6AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_3247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.828ecd7e83541dacc7e28305d6488e1c.svg";
export { ForwardRef as ReactComponent };